import React, { useState } from "react";
import type { FieldValues } from "react-hook-form";

import {
  IconButton,
  InputAdornment,
} from "@braintrust/braintrust-ui-components";
import {
  VisibilityOffOutlinedIcon,
  VisibilityOutlinedIcon,
} from "@braintrust/braintrust-ui-components/Icons";
import type { RhfTextFieldProps } from "@js/rhf/fields/text/";
import { RhfTextField } from "@js/rhf/fields/text/";

type RhfPasswordFieldProps<T extends FieldValues> = RhfTextFieldProps<T> & {
  //special data atribute to prevent LastPass from filling this field
  "data-lpignore"?: "true";
};

export const RhfPasswordField = <T extends FieldValues>({
  slotProps,
  ...props
}: RhfPasswordFieldProps<T>) => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <RhfTextField
      {...props}
      type={showPassword ? "text" : "password"}
      slotProps={{
        ...slotProps,
        input: {
          ...slotProps?.input,
          endAdornment: (
            <InputAdornment variant="filled" position="end">
              <IconButton
                aria-label="Toggle password visibility"
                onClick={() => setShowPassword((value) => !value)}
                variant="transparent"
              >
                {showPassword ? (
                  <VisibilityOffOutlinedIcon />
                ) : (
                  <VisibilityOutlinedIcon />
                )}
              </IconButton>
            </InputAdornment>
          ),
        },
      }}
    />
  );
};
